module.exports = __webpack_public_path__ + "img/logo.bc771774.png";